module.exports = __webpack_public_path__ + "static/media/clientLogo_iperbimbo.59bcf861.png";